var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"plusbig-icon",attrs:{"height":"100%","viewBox":"0 0 42 42","fill":"none"}},[_c('path',{attrs:{"d":"M21 0.5V41.5","stroke-width":"2"}}),_c('path',{attrs:{"d":"M0.5 21L41.5 21","stroke-width":"2"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }